import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type CtaBandProps = {
  title: string;
  description: string;
  primary: {
    label: string;
    to: string;
  };
  secondary?: {
    label: string;
    to: string;
  };
  tone?: 'green' | 'ink';
};
export function CtaBand({
  title,
  description,
  primary,
  secondary,
  tone = 'green'
}: CtaBandProps) {
  return <section className={tone === 'green' ? 'bg-green-800' : 'bg-ink'} data-id="element-577" data-mp="v2sfs8trq3wu">
      <div className="mx-auto flex max-w-content flex-col gap-6 px-4 py-14 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10 lg:py-16" data-id="element-578" data-mp="v43l4d2v3jq2">
        <div className="max-w-2xl" data-id="element-579" data-mp="m1kj1v6whb4v">
          <h2 className="font-display text-[26px] leading-tight text-white sm:text-[32px]" data-id="element-580" data-mp="m2m50upgfi1d">
            {title}
          </h2>
          <p className="mt-3 text-[16px] leading-relaxed text-white/70" data-id="element-581" data-mp="h5c7ssvtq22z">{description}</p>
        </div>
        <div className="flex flex-wrap items-center gap-3" data-id="element-582" data-mp="2gdr4rnxf7abf">
          <Link to={primary.to} className="inline-flex h-[52px] items-center gap-2 rounded-lg bg-white px-7 text-[15px] font-semibold text-ink transition-colors duration-150 ease-emphasis hover:bg-sand-100" data-id="element-583" data-mp="2bibt92mvxqi6">
            {primary.label}
            <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-584" data-mp="2f8p85pl06g0r" />
          </Link>
          {secondary && <Link to={secondary.to} className="inline-flex h-[52px] items-center rounded-lg border border-white/35 px-7 text-[15px] font-semibold text-white transition-colors duration-150 ease-emphasis hover:bg-white/10" data-id="element-585" data-mp="2k81so3oejb06">
              {secondary.label}
            </Link>}
        </div>
      </div>
    </section>;
}